import React from "react";
import * as SC from "./PrintPostEditorSnapchat.styled";

import logger from "../../../../../../utils/LoggerFrontend";
import { ExpandUpIcon } from "../../../../Previews/Svg";
import { channelsByShortName } from "../../../../../../data/app__channels";
import PrintCampaignCreateChannelDataEditor from "../../print-channel-editor/PrintCampaignCreateChannelDataEditor";
import PrintTemplateEditor from "../../print-campaign-template-editor/PrintTemplateEditor";
import { useTranslation } from "react-i18next";

const PrintPostEditorSnapchat = ({
  postData,
  channel,
  channelData,
  editable,
  selectedCreativeIndexToEdit,
  mediaAssetsProps,
  mediaAssets
}) => {
  const { t } = useTranslation();
  logger.debug("PostEditorSnapchat:render", "render:", {
    postData,
    channelData,
    editable
  });

  const templatePreviewSizes = {
    minHeight: SC.SNAPCHAT_IMAGE_SIZE_SPEC.minHeight,
    maxHeight: SC.SNAPCHAT_IMAGE_SIZE_SPEC.maxHeight,
    width: SC.SNAPCHAT_IMAGE_SIZE_SPEC.pictureWidth,
    minAspect: channelsByShortName.snapchat.minAspect,
    maxAspect: channelsByShortName.snapchat.maxAspect
  };

  return (
    <SC.PostEditorSnapchatWrapper>
      <SC.SnapchatWrapper>
        <SC.HeaderWrapper>
          <PrintCampaignCreateChannelDataEditor
            value={channelData.companyName}
            dataKey="companyName"
            textStyle={SC.companyNameStyle}
            limit={channelsByShortName.snapchat.limits.companyName}
            label={t("Company name")}
            tooltip={t("Company name")}
            editable={editable}
            dark
          />
          <PrintCampaignCreateChannelDataEditor
            value={channelData.title}
            dataKey="title"
            textStyle={SC.titleStyle}
            limit={channelsByShortName.snapchat.limits.title}
            label={t("Job Title")}
            tooltip={t("Job Title")}
            editable={editable}
            dark
          />
        </SC.HeaderWrapper>
        <PrintTemplateEditor
          mediaAssets={mediaAssets}
          mediaAssetsProps={mediaAssetsProps}
          selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
          templatePreviewSizes={templatePreviewSizes}
          channel={channel}
        />
        <SC.FooterWrapper>
          <ExpandUpIcon />
          <SC.LearnMoreAnchor target="_blank" href={channelData.url}>
            {t("More")}
          </SC.LearnMoreAnchor>
        </SC.FooterWrapper>
        <SC.AdText>Ad</SC.AdText>
      </SC.SnapchatWrapper>
    </SC.PostEditorSnapchatWrapper>
  );
};

export default PrintPostEditorSnapchat;
